import {useState, useEffect} from 'react';


export default function useResize() {
    const [innerWidth, setInnerWidth] = useState(window.innerWidth);

    useEffect(() => {
        window.addEventListener('resize', () => setInnerWidth(window.innerWidth));
        return () => null;
    }, [innerWidth])

    return {innerWidth}
}